<script>
import {Tabs} from 'element-ui';
import SegmentedControl from '../../../shared/SegmentedControl.vue';
export default {
 name:'SegmentedTabs',inheritAttrs:false,props:{value:String},
 methods:{choose(name,label,index){if(name===this.value)return;this.$emit('input',name);this.$nextTick(()=>this.$emit('tab-click',{name,label,index:String(index)}))}},
 render(h){const panes=(this.$slots.default||[]).filter(v=>v.componentOptions);return h('div',{class:'segmented-panels'},[
  h(SegmentedControl,panes.map((pane,index)=>{const p=pane.componentOptions.propsData||{},name=p.name??String(index);return h('button',{key:name,attrs:{'aria-pressed':this.value===name,disabled:p.disabled},on:{click:()=>this.choose(name,p.label,index)}},[p.label])})),
  h(Tabs,{class:'segmented-panel-content',props:{...this.$attrs,value:this.value},on:{...this.$listeners,input:value=>this.$emit('input',value)}},this.$slots.default)
 ]);}
};
</script>
<style>
#app .segmented-panels>.segmented-panel-content>.el-tabs__header{display:none!important}
#app .segmented-panels{min-width:0;width:100%}
</style>
